const DESKTOP_MENU_MIN_WIDTH = 990;

let syntheticResizeInProgress = false;
let layoutRefreshScheduled = false;

function getHeaderState() {
  const header = document.querySelector('#header-component');
  if (!(header instanceof HTMLElement)) return null;

  const overflowList = header.querySelector('overflow-list');
  const hasReachedMinimum = overflowList?.hasAttribute('minimum-reached') ?? false;
  const shouldUseDesktopMenu = window.innerWidth >= DESKTOP_MENU_MIN_WIDTH && !hasReachedMinimum;

  return { header, shouldUseDesktopMenu };
}

function enforceDesktopHeaderMode() {
  const state = getHeaderState();
  if (!state) return;

  const { header, shouldUseDesktopMenu } = state;

  if (shouldUseDesktopMenu && header.dataset.menuStyle !== 'menu') {
    header.dataset.menuStyle = 'menu';
  }
}

function refreshHeaderLayout() {
  if (layoutRefreshScheduled) return;
  layoutRefreshScheduled = true;

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      layoutRefreshScheduled = false;
      enforceDesktopHeaderMode();

      const state = getHeaderState();
      if (!state?.shouldUseDesktopMenu || syntheticResizeInProgress) return;

      // Horizon calculates parts of the header grid during resize. On an initial
      // desktop page load, menu mode can be correct while the drawer layout is
      // still painted. Trigger one guarded resize so native components recalculate.
      syntheticResizeInProgress = true;
      void state.header.offsetWidth;
      window.dispatchEvent(new Event('resize'));

      window.requestAnimationFrame(() => {
        enforceDesktopHeaderMode();
        syntheticResizeInProgress = false;
      });
    });
  });
}

function initializeWelluviHeaderMode() {
  const state = getHeaderState();
  if (!state) return;

  enforceDesktopHeaderMode();
  refreshHeaderLayout();

  const observer = new MutationObserver(() => {
    if (!syntheticResizeInProgress) refreshHeaderLayout();
  });

  observer.observe(state.header, {
    attributes: true,
    attributeFilter: ['data-menu-style'],
    subtree: true,
  });

  window.addEventListener(
    'resize',
    () => {
      if (!syntheticResizeInProgress) enforceDesktopHeaderMode();
    },
    { passive: true }
  );

  window.addEventListener('load', refreshHeaderLayout, { once: true });

  if (document.fonts?.ready) {
    document.fonts.ready.then(refreshHeaderLayout).catch(() => {});
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWelluviHeaderMode, { once: true });
} else {
  initializeWelluviHeaderMode();
}
